import request from '@/utils/requestVr'

export function fetchList(query) {
    return request({
        url: '/vr/scheme/tenant/page',
        method: 'get',
        params: query,
    })
}

export function addObj(query) {
    return request({
        url: '/vr/scheme/tenant/add',
        method: 'post',
        data: query,
    })
}

export function editObj(query) {
    return request({
        url: '/vr/scheme/edit',
        method: 'post',
        data: query,
    })
}
// 设置VR租户方案
export function tantEdit(data) {
  return request({
    url: '/vr/scheme/tenant/edit',
    method: 'post',
     data: data,
  })
}
// 检验VR详情
export function tenantVrDetail(query) {
  return request({
    url: '/vr/scheme/tenant/detail',
    method: 'get',
    params: query,
  })
}
export function getObj(tenantId) {
    return request({
        url: '/vr/scheme/tenant/detail?tenantId=' + tenantId,
        method: 'get',
    })
}

export function delObj(data) {
    return request({
        url: '/vr/scheme/delete',
        method: 'post',
        data: data,
    })
}

 